import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { LoadingFailedBox, NgBreadcrumbItem, NgBreadcrumbs, NgPageHeader } from '@/ui';
import { incidentDetailRoute } from '@/features/shared/routes';
import { fetchIncidentLiveVideos, recordingsQueryKey } from './recordingsApi';
import { VideoRecordingListComponent } from './VideoRecordingListComponent';
import { VideoRecordingListLoadingPlaceholder } from './VideoRecordingListLoadingPlaceholder';

export function RecordingListPage() {
  const { t } = useTranslation();
  const { incidentId = '' } = useParams<{ incidentId: string }>();

  const pageTitle = t('PageTitle_ListOfRecordings');

  const {
    data: liveVideos,
    isError: showError,
    isFetching: isLoading,
  } = useQuery({
    queryKey: recordingsQueryKey(incidentId),
    queryFn: () => fetchIncidentLiveVideos(incidentId),
  });

  return (
    <div className="content p-3">
      <NgBreadcrumbs>
        <NgBreadcrumbItem title={t('PageTitle_Incident')} to={incidentDetailRoute(incidentId)} />
      </NgBreadcrumbs>

      <NgPageHeader title={pageTitle} />
      <h1>{pageTitle}</h1>

      {isLoading ? (
        <VideoRecordingListLoadingPlaceholder />
      ) : showError ? (
        <LoadingFailedBox />
      ) : (
        <VideoRecordingListComponent incidentId={incidentId} liveVideos={liveVideos ?? []} />
      )}
    </div>
  );
}
